import React from 'react'
import QRCode from 'react-qr-code'
import { t } from '@lingui/core/macro'
import { getReasonMessage } from '../../utils/apple'
import styles from './QrApplePay.module.css'

const QrApplePay = () => {
    const message = getReasonMessage()
    const url = window.location.href

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>{t`Оплата через Apple Pay`}</h2>
            <p className={styles.text}>{message}</p>

            <div className={styles.qrSection}>
                <div className={styles.qrCode}>
                    <QRCode
                        size={256}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={url}
                        viewBox={`0 0 256 256`}
                    />
                </div>
                <div className={styles.instruction}>
                    <h3 className={styles.instructionTitle}>{t`Как оплатить с устройства Apple:`}</h3>
                    <ol className={styles.instructionList}>
                        <li>{t`Откройте камеру на iPhone или iPad`}</li>
                        <li>{t`Наведите на QR-код выше`}</li>
                        <li>{t`Нажмите на появившееся уведомление`}</li>
                        <li>{t`Завершите оплату через Apple Pay`}</li>
                    </ol>
                </div>
            </div>
        </div>
    )
}

export default QrApplePay
